// Prevent modal backdrops from closing when a drag-select starts inside the dialog and ends on the backdrop.
const isBackdrop = (el) => el instanceof HTMLElement && el.classList.contains("fixed") && el.classList.contains("inset-0");

export function installBackdropDragGuard() {
  let downTarget = null;
  window.addEventListener("mousedown", (e) => { downTarget = e.target; }, true);
  window.addEventListener("click", (e) => {
    if (isBackdrop(e.target) && downTarget && downTarget !== e.target) {
      e.stopPropagation();
    }
    downTarget = null;
  }, true);
}
